import { trainOnlyLihes } from "./trainOnlyLihes";
import { isTravelskiExpress } from "./index";

export type BookingSection =
  | 'stationHeader'
  | 'bookingDate'
  | 'prestationInfo'
  | 'panelAction'
  | 'accommodationOption'
  | 'packageSection'

/**
 * Helper function to check if a lihe should have sections hidden
 * @param liheId - The liheId of the booking
 * @param liheName - Optional liheName of the booking
 * @param packageCode - Optional packageCode of the booking
 * @returns true if sections should be hidden (is Travelski Express), false otherwise
 */
export const shouldHideSections = (liheId: number, liheName?: string, packageCode?: string): boolean => {
  return isTravelskiExpress(liheId, liheName, packageCode)
}

export const LIHE_HIDDEN_SECTIONS: Record<BookingSection, number[]> = {
  // Example rules:
  stationHeader: [...trainOnlyLihes],
  bookingDate: [...trainOnlyLihes],
  prestationInfo: [...trainOnlyLihes],
  panelAction: [...trainOnlyLihes],
  accommodationOption: [...trainOnlyLihes],
  packageSection: [...trainOnlyLihes]
};

